import { render } from "./Testimonial2Page.vue?vue&type=template&id=aa7c50f4&scoped=true&ts=true"
import script from "./Testimonial2Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial2Page.vue?vue&type=script&lang=ts"

import "./Testimonial2Page.vue?vue&type=style&index=0&id=aa7c50f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7c50f4"]])

export default __exports__